import { render, staticRenderFns } from "./provinceFixPriceForFinance.vue?vue&type=template&id=51f7ce77&scoped=true"
import script from "./provinceFixPriceForFinance.vue?vue&type=script&lang=js"
export * from "./provinceFixPriceForFinance.vue?vue&type=script&lang=js"
import style0 from "./provinceFixPriceForFinance.vue?vue&type=style&index=0&id=51f7ce77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f7ce77",
  null
  
)

export default component.exports